import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AlertCircle, CheckCircle2, Info, X } from 'lucide-angular';

import { IconComponent } from '../icon/icon.component';
import { ToastAction, ToastService, ToastType } from '../../services/toast.service';

@Component({
  selector: 'app-toast-stack',
  imports: [IconComponent],
  templateUrl: './toast-stack.component.html',
  styleUrl: './toast-stack.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastStackComponent {
  protected readonly toastService = inject(ToastService);
  protected readonly toasts = this.toastService.toasts;

  protected readonly icons = {
    success: CheckCircle2,
    error: AlertCircle,
    info: Info,
  } as const;

  protected readonly closeIcon = X;

  protected iconFor(type: ToastType) {
    return this.icons[type];
  }

  protected onDismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  /** Ejecuta la acción (si trae `run`) y descarta el toast. */
  protected onAction(id: string, action: ToastAction): void {
    action.run?.();
    this.toastService.dismiss(id);
  }
}
